import { useMemo } from 'react'

import { StatusOption } from '@/containers/billing/register/billingFilters/constants/statusOptions'
import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { useCustomerCategoriesQuery } from '@/hooks/business/useCustomerCategoriesQuery'

export function useCustomerCategories() {
  const { businessData } = useBusinessDataQuery({})

  const {
    customerCategories,
    isLoadingCustomerCategories,
    isErrorCustomerCategories,
    errorCustomerCategories,
  } = useCustomerCategoriesQuery({
    businessId: businessData?.id ?? 0,
    options: {
      enabled: !!businessData?.id,
    },
  })

  // Transform customer categories for SelectFilter
  const categoryOptions: StatusOption[] = useMemo(() => {
    if (!customerCategories || customerCategories.length === 0) {
      return [{ value: 'all', label: 'Todas las categorías' }]
    }

    return [
      { value: 'all', label: 'Todas las categorías' },
      ...customerCategories.map((category) => ({
        value: category.id.toString(),
        label: category.name,
      })),
    ]
  }, [customerCategories])

  // Convert category IDs to string array for SelectFilter
  const categoriesToStringArray = (categoryIds?: number[]) => {
    if (!categoryIds || categoryIds.length === 0) {
      return ['all']
    }
    return categoryIds.map((id) => id.toString())
  }

  // Convert string array from SelectFilter to category IDs
  const stringArrayToCategories = (selectedCategories: string[]) => {
    if (selectedCategories.includes('all') || selectedCategories.length === 0) {
      return []
    }
    return selectedCategories
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id))
  }

  return {
    categoryOptions,
    categoriesToStringArray,
    stringArrayToCategories,
    isLoading: isLoadingCustomerCategories,
    hasError: isErrorCustomerCategories,
    error: errorCustomerCategories,
  }
}
